
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { Link } from 'react-router-dom';

import TableListFooter from 'core/TableListFooter';
import Layout from 'components/Dashboard/Layout';
import { ListContext, ListProvider } from 'core/ListProvider';
import AddIcon from '@material-ui/icons/Add';
import { YellowButton } from 'ui/Button';
import SearchWidget from 'form/SearchWidget';
import { UserContext, hasAccountPermission } from 'components/User';
import DriverListTable from './ListTable';
import { ResponsiveTable } from 'ui/Table';
import { SelectButtonGroupWidget } from 'form/SelectButtonGroupWidget';


export default class DriverList extends Component {

  static contextType = UserContext;

  componentDidMount() {
    document.title = 'Водители';
  }

  onDetail = (item) => {
    this.props.history.push(`/driver/${item.id}`);
  };

  render() {
    const canAdd = hasAccountPermission(this.context, 'fleet.add_driver');

    return (
      <ListProvider
        url={'fleet/driver'}
        filterDefaultValues={{
          is_fired: false
        }}
      >
        <ListContext.Consumer>
          {context => {
            const { items } = context;
            const addButton = canAdd
              ? (
                <YellowButton component={Link} to={`/driver/add`} startIcon={<AddIcon />}>
                  Добавить водителя
                </YellowButton>
              )
              : undefined;

            return (
              <Layout>
                <Layout.Header
                  title={'Водители'}
                  search={
                    <SearchWidget
                      value={context.filter.last_name__icontains}
                      onChange={(value) => context.setFilterValue('last_name__icontains', value)}
                    />
                  }
                  right={addButton}
                />
                <Layout.Filter>
                  <SelectButtonGroupWidget
                    value={context.filter.is_fired}
                    options={[
                      {value: false, label: 'Работающие'},
                      {value: true, label: 'Уволенные'},
                      {value: null, label: 'Все'},
                    ]}
                    onChange={(value) => context.setFilterValue('is_fired', value)}
                  />
                </Layout.Filter>
                <Layout.ContentSimple>
                  <TableContainer component={Paper}>
                    <ResponsiveTable>
                      <DriverListTable
                        items={items}
                        onDetail={(item) => this.onDetail(item)}
                      />
                      <TableListFooter colspan={3} />
                    </ResponsiveTable>
                  </TableContainer>
                </Layout.ContentSimple>
              </Layout>
            )
          }}
        </ListContext.Consumer>
      </ListProvider>
    )
  }
}
